import { Component, OnInit } from '@angular/core';
import { AddressBookService } from '../../../data/address-book.service';
import { TableColumnService } from '../../shared/services/table-column.service';
import { AddressBooksData } from './address-books.data';
import { Store } from '@ngrx/store';
import { AppState } from '../../../store';
import { addressBooksTableRequest } from '../../../store/address-books-table/address-books-table.actions';
import { AddressBookTableService } from '../../shared/tables/address-book-table.service';
import { MatPaginator } from '@angular/material/paginator';
import { RouterLink } from '@angular/router';
import { MatAnchor } from '@angular/material/button';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatSort, MatSortHeader } from '@angular/material/sort';
import { MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-address-book-table',
    templateUrl: './address-book-table.component.html',
    styleUrls: ['./address-book-table.component.scss'],
    imports: [MatProgressSpinner, MatTable, MatSort, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCheckbox, MatCellDef, MatCell, MatSortHeader, MatAnchor, RouterLink, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatPaginator, AsyncPipe]
})
export class AddressBookTableComponent implements OnInit {

    constructor(private store: Store<AppState>, private addressBookService: AddressBookService,
                private tableColumnService: TableColumnService, public table: AddressBookTableService) {
    }

    dataSource = new AddressBooksData(this.table.currentPageEntries$);

    ngOnInit(): void {
        this.store.dispatch(addressBooksTableRequest());
    }

}
